import {productService} from "@/modules/products/services/productService.js";
const savedFilter = sessionStorage.getItem('productsTextFilter') || '';
const state = {
  products: [],
  hasLoadedProducts: false,
  currentPageIndex: 1,
  perPage: 10,
  filterText: savedFilter,
  hasProducts: false,
};

const getters = {
  products: (state) => state.products,
  filteredProducts: (state) => {
    const filterText = state.filterText
    if(!filterText) {
      return state.products
    }
    return state.products.filter(product => product.name.toLowerCase().indexOf(filterText.toLowerCase()) !== -1)
  },
  hasLoadedProducts: (state) => state.hasLoadedProducts,
  filterText: (state) => state.filterText,
  hasProducts: state => state.hasProducts,
  productIdMap: state => {
    const res = {};
    state.products.forEach(product => res[product.id] = true)
    return res
  }
};

const mutations = {
  setProducts(state, products) {
    state.products = products
  },
  setLoadedProducts(state, hasLoadedProducts) {
    state.hasLoadedProducts = hasLoadedProducts
  },
  incrementCurrentPageIndex(state) {
    state.currentPageIndex++;
  },
  setFilterText(state, filterText ) {
    state.filterText = filterText || ''
    sessionStorage.setItem('productsTextFilter', filterText || '');
  },
  resetParameters(state) {
    state.currentPageIndex = 1
    state.hasLoadedProducts = false
  },
  setHasProducts(state, hasProducts) {
    state.hasProducts = hasProducts
  },
}

const actions = {
  async loadProducts({commit, state, getters}, resetProducts = false) {
    if(resetProducts) {
      commit('resetParameters')
    } else {
      if(state.hasLoadedProducts) {
        return
      }
    }

    const getParams = {per_page: state.perPage, page: state.currentPageIndex}

    if(state.filterText) {
      getParams['filter[name][contains]'] = state.filterText
    }
    let products = (await productService.get(getParams)).data.products
    if(resetProducts) {
      commit('setProducts', [])
    }
    products = products || []
    if (products.length < state.perPage) {
      commit('setLoadedProducts', true)
    }
    const productIdMap = getters.productIdMap
    let res = resetProducts ? products : state.products.concat(products.filter(product => !productIdMap[product.id]))
    commit('setProducts', res)
    commit('incrementCurrentPageIndex')
    return res
  },
  async setFilterText({commit, state, dispatch}, filterText) {
    commit('setFilterText', filterText)
    await dispatch('loadProducts', true)
  },
  async createProduct({commit, state, dispatch}, product) {
    let res = await productService.create({product})
    dispatch('loadProducts', true)
    return res
  },
  async editProduct({commit, state, dispatch}, product) {

    const changedProductFields = {id: product.id}
    const originalProduct = state.products.find(stateProduct => stateProduct.id === product.id)
    const originalProductTaxIds = originalProduct.taxes.map(tax => tax.id).filter(tax => tax).sort()
    const newProductTaxIds = product.tax_ids && product.tax_ids.filter(tax => tax).sort()
    if(newProductTaxIds) {
      const taxesWereChanged = originalProductTaxIds.length !== newProductTaxIds.length ||
        newProductTaxIds.some((taxId,idx) => originalProductTaxIds[idx] !== taxId)
      if( taxesWereChanged ) {
        changedProductFields.tax_ids = product.tax_ids
      }
    }
    const fieldsToCompare = ['description', 'display', 'image_url', 'name', 'price']
    fieldsToCompare.forEach(field => {
      if(product[field] !== originalProduct[field]) {
        changedProductFields[field] = product[field]
      }
    })
    let res = await productService.edit({product: changedProductFields})
    dispatch('loadProducts', true)
    return res
  },
  async deleteProduct({commit, state, dispatch}, product) {
    try {
      const productId = product.id
      let res = await productService.remove(productId)
      dispatch('setHasProducts')
      dispatch('loadProducts', true)
      return res
    } catch (e) {
      throw e;
    }
  },
  async setHasProducts({commit}) {
    const getParams = {per_page: 10, page: 1}
    let products = (await productService.get(getParams)).data.products
    const res = !!products.length
    commit('setHasProducts', res)
    return res
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
